import * as React from "react";

import FilterCheck from "./FilterCheck";
import MetamodelStore from '../../resources/data/MetamodelStore';
import Config from '../../Config';

import '../../styles/FilterCheck.css';

/**
 * Simple list with checkboxes representing objects
 */
export default class FilterCheckObjSimple extends FilterCheck
{
    render()
    {
        const { aItems, aAddExtraData, onChangeCallback } = this.props;
        if (!aItems || !aItems.length || 0 >= aItems.length)
        {
            return null;
        }
        var aItemsData = MetamodelStore.getObjectsByID(aItems);

        return (
            <div className="FilterCheck__objectSimple">
                {aItemsData.map(aItemData =>
                {
                    if(!aItemData){
                        return null;
                    }
                    let sLabel = '';
                    let sName = '';
                    let sID = '';

                    sLabel = Config.getLangName(aItemData);
                    if (Object.hasOwnProperty.call(aItemData, 'sName') && typeof aItemData.sName === 'string' && aItemData.sName != '')
                    {
                        sName = aItemData.sName;
                    }
                    if (Object.hasOwnProperty.call(aItemData, 'id') && typeof aItemData.id === 'string' && aItemData.id != '')
                    {
                        sID = aItemData.id;
                    }

                    return (
                        <div key={aItemData.id}>
                            <input
                                type="checkbox"
                                onChange={(aEvent) =>
                                {
                                    if (aAddExtraData && Object.hasOwnProperty.call(aAddExtraData, 'id') && aAddExtraData.id && sID)
                                    {
                                        this.handleChange(aEvent, {
                                            id: sID,
                                        });
                                    } else
                                    {
                                        this.handleChange(aEvent);
                                    }

                                    if (onChangeCallback && typeof onChangeCallback === 'function')
                                    {
                                        onChangeCallback();
                                    }
                                }}
                                name={sName}
                            />
                            <label>
                                {sLabel}
                            </label>
                        </div>
                    )
                })}
            </div>
        );
    }
}
